import { Wrench, ShoppingBag, CreditCard } from 'lucide-react';
import { WizardOption } from '../WizardOption';

export type WalkInPurpose = 'service' | 'abholung' | 'verkauf';

interface AppointmentTypeStepProps {
  onSelect: (purpose: WalkInPurpose) => void;
}

export function AppointmentTypeStep({ onSelect }: AppointmentTypeStepProps) {
  return (
    <div>
      <p className="text-slate-300 mb-4">Um was geht es?</p>

      <div className="space-y-3">
        <WizardOption
          icon={Wrench}
          title="Service / Reparatur"
          description="Wartung, Inspektion, Reparatur"
          variant="warning"
          onClick={() => onSelect('service')}
        />

        <WizardOption
          icon={ShoppingBag}
          title="Abholung"
          description="Bestelltes Fahrrad oder Zubehör abholen"
          variant="success"
          onClick={() => onSelect('abholung')}
        />

        <WizardOption
          icon={CreditCard}
          title="Verkauf"
          description="Fahrrad oder Zubehör verkaufen"
          variant="info"
          onClick={() => onSelect('verkauf')}
        />
      </div>
    </div>
  );
}
